import { alpha } from '@mui/material/styles'

export default function RaRichTextInput(theme): object {
  return {
    RaRichTextInput: {
      styleOverrides: {
        root: {
          width: '100%',
          '&.Mui-error': {
            '& .ProseMirror': {
              borderColor: `${theme.palette.error.main} !important`,
            },
          },
          '& .RaRichTextInput-editorContent': {
            wordBreak: 'break-word',
            '& .ProseMirror': {
              borderColor: alpha(theme.palette.grey['500'], 0.32),
              backgroundColor: theme.palette.common.white,
              padding: theme.spacing(2),
              '&.ProseMirror-focused': {
                borderColor: theme.palette.primary.main,
                outline: 'none',
                borderWidth: 2,
              },
              '& blockquote': {
                borderLeft: `3px solid ${theme.palette.grey[400]}`,
                backgroundColor: theme.palette.grey[200],
                padding: theme.spacing(1, 2),
              },
              '& hr': {
                border: `thin solid ${theme.palette.grey[400]}`,
                height: 'auto',
              },
            },
          },
        },
      },
    },
  }
}
